import React from 'react';
import styled from 'styled-components';
import TextTagStation from './TextTagStation';

const TextMetaStation: React.FC = () => {
  return (
    <TextMetaStationContainer>
      <TextTagStation />
    </TextMetaStationContainer>
  );
}

export default TextMetaStation;

const TextMetaStationContainer = styled.div`
  width: 100%;
  height: calc(9.8vh);
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 5vw;
  margin-bottom: 4px;
`;
